"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFilter = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _filterButton = require("./filter-button");

var _icons = require("./icons");

var _jsxRuntime = require("react/jsx-runtime");

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-etwa1c-0"
})(["display:flex;overflow-x:auto;align-items:flex-start;justify-content:flex-start;& > ", "{width:100px;margin:0 24px;}& > ", ":first-child{margin-left:0;}& > ", ":last-child{margin-right:0;}"], _filterButton.FilterButton, _filterButton.FilterButton, _filterButton.FilterButton);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-etwa1c-1"
})(["display:flex;flex-direction:row;align-items:flex-start;justify-content:center;overflow-x:hidden;& > ", "{flex:0 1 auto;}"], Container);

var Filter = function Filter(_ref) {
  var className = _ref.className,
      filters = _ref.filters,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$activeFilters = _ref.activeFilters,
      activeFilters = _ref$activeFilters === void 0 ? {} : _ref$activeFilters,
      _ref$resetFiltersText = _ref.resetFiltersText,
      resetFiltersText = _ref$resetFiltersText === void 0 ? 'View All' : _ref$resetFiltersText,
      _ref$enableMultipleCh = _ref.enableMultipleChoiceFilters,
      enableMultipleChoiceFilters = _ref$enableMultipleCh === void 0 ? false : _ref$enableMultipleCh,
      _ref$disableResetFilt = _ref.disableResetFilter,
      disableResetFilter = _ref$disableResetFilt === void 0 ? false : _ref$disableResetFilt;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
      children: [filters.map(function (_ref2) {
        var _CREDIT_CARD_FILTER_I;

        var name = _ref2.name,
            options = _ref2.options;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterButton.FilterButton, {
          name: name,
          icon: (_CREDIT_CARD_FILTER_I = _icons.CREDIT_CARD_FILTER_ICON_MAP[name.toLowerCase()]) !== null && _CREDIT_CARD_FILTER_I !== void 0 ? _CREDIT_CARD_FILTER_I : null,
          options: options,
          activeFilters: activeFilters,
          enableMultipleChoiceFilters: enableMultipleChoiceFilters,
          onChange: onChange,
          children: name
        }, name);
      }), !disableResetFilter ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterButton.FilterButton, {
        icon: "https://assets.nav.com/design-assets/icons/logged-out/System/squares.svg",
        onClick: function onClick() {
          return onChange({});
        },
        name: resetFiltersText,
        children: resetFiltersText
      }) : null]
    })
  });
};

var IconFilter = (0, _styledComponents["default"])(Filter).withConfig({
  displayName: "IconFilter",
  componentId: "sc-etwa1c-2"
})([""]);
exports.IconFilter = IconFilter;
IconFilter.displayName = 'IconFilter';
//# sourceMappingURL=index.js.map